import { Injectable } from '@angular/core';
import { CONTROLLERS, ENDPOINTS } from 'src/app/constants';
import { ApiService } from '../api.service';
import { MemberReportListReqCommand, MemberReportListResp, MemberReportViewList, Response } from 'src/app/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MemberReportService {
  private api: string = CONTROLLERS.TENANTS.MEMBER_MODULE_REPORT;
  constructor(private apiService: ApiService) { }

  getMemberReportList(
    memberReportListReqCommand: MemberReportListReqCommand
  ): Observable<Response<MemberReportListResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.MEMBER_MODULE_REPORT.GET_REPORT_BY_MODULE_MEMBER}`,
      memberReportListReqCommand
    );
  }

  getAllMemberReportList(
    memberReportListReqCommand: MemberReportListReqCommand
  ): Observable<Response<MemberReportViewList[]>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.MEMBER_MODULE_REPORT.GET_ALL_REPORT_BY_MODULE_MEMBER}`,
      memberReportListReqCommand
    );
  }
}
